export default __webpack_public_path__ + "static/media/Cartpage.cae879b0.png";